import IEntity from "./Entity";
import IAddress from "./Address";
import IMei from "./IMei";

export default interface IUser extends IEntity {
	_id?: string;
	username?: string;
	avatar?: string;
	email: string;
	fullName?: string;
	name: string;
	lastname: string;
	status: MeiStatus;
	userStatus: UserStatus;
	bankStatus: BankStatus;
	role: string;
	roles: string[] | any;
	phoneNumber: string | any;
	birthDate?: string;
	cpf: string;
	address: IAddress;
	mei?: IMei;
}

export enum UserStatus {
	disabled = 0,
	enabled = 1
}

export enum BankStatus {
	NoAccount = 0,
	Pending = 1,
	Enabled = 2,
	Actived = 3,
	Deleted = 4
}

export enum MeiStatus {
	pending = 0,
	noMei = 1,
	createMei = 2,
	done = 3,
	phoneNotValidated = 4,
	responsibleForAnotherBusinessError = 5,
	noGovBrAccount = 6,
	errorOnFinishe = 7,
	meiCreated = 8,
	errorOnGetMei = 9,
	invalidBirthDate = 10
}
